module.exports = __webpack_public_path__ + "static/media/tos(5).6b4c125c.pdf";